export const defaultProps = {
  className: '',
  percent: 0,
  prefixCls: 'rc-progress',
  strokeLinecap: 'round',
  strokeWidth: 1,
  style: {},
  trailWidth: 1,
};
